module.exports = __webpack_public_path__ + "components/flag/static/square/cefta-aac0494a5f8b71f5c8725f216c446fb7.svg";